import { withSvgIcon } from './withSvgIcon';

export const Google = withSvgIcon(
  <>
    <path
      d="M21.7875 12.225C21.7875 11.5667 21.7292 10.9417 21.6292 10.3334H12.2125V14.0917H17.6042C17.3625 15.325 16.6542 16.3667 15.6042 17.075V19.575H18.8209C20.7042 17.8334 21.7875 15.2667 21.7875 12.225Z"
      fill="#4285F4"
    />
    <path
      d="M12.2125 22C14.9125 22 17.1708 21.1 18.8208 19.575L15.6041 17.075C14.7041 17.675 13.5625 18.0417 12.2125 18.0417C9.60414 18.0417 7.39581 16.2833 6.60414 13.9083H3.28748V16.4833C4.92914 19.75 8.30414 22 12.2125 22Z"
      fill="#34A853"
    />
    <path
      d="M6.60419 13.9083C6.39586 13.3083 6.28752 12.6666 6.28752 11.9999C6.28752 11.3333 6.40419 10.6916 6.60419 10.0916V7.5166H3.28752C2.60419 8.8666 2.21252 10.3833 2.21252 11.9999C2.21252 13.6166 2.60419 15.1333 3.28752 16.4833L6.60419 13.9083Z"
      fill="#FBBC05"
    />
    <path
      d="M12.2125 5.95833C13.6875 5.95833 15.0041 6.46667 16.0458 7.45834L18.8958 4.60833C17.1708 2.99167 14.9125 2 12.2125 2C8.30414 2 4.92914 4.25 3.28748 7.51667L6.60414 10.0917C7.39581 7.71667 9.60414 5.95833 12.2125 5.95833Z"
      fill="#EA4335"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
